import React, { useEffect, useState, useRef } from "react";
import $ from "jquery";
import defaultBox from "../../../images/img/default-box.png";
import ScrollerWithArrows from "../../../Simplify360Chat/CommonUtils/ScrollerWithArrows";

import "./BoxSelectionComponent.css";

export default function BoxSelectionComponent(props) {
  const { data, code, tag, onClickHandler, filterToggle } = props;

  const [boxData, setBoxData] = useState(data);
  const [refresh, setRefresh] = useState(false);

  const [isShowBtn, setIsShowBtn] = useState(false);

  const [lastIndexChannel, setLastIndexChannel] = useState(data.length - 1);

  const [showChannelLeft, setShowChannelLeft] = useState(false);

  console.log("datas", data, data.length);

  const [showChannelRight, setShowChannelRight] = useState(
    data.length > 3 ? true : false
  );

  const buttonText = props.buttonText;

  const boxRef = useRef(null);

  useEffect(() => {
    boxData.map((bData) => (bData.checked = false));
  }, []);

  const boxSelectionClickHandler = (box) => {
    var newBoxData = [];
    if (box.checked === false) {
      for (let i = 0; i < boxData.length; i++) {
        if (boxData[i].boxId === box.boxId) {
          boxData[i].checked = true;
        } else {
          boxData[i].checked = false;
        }
        newBoxData.push(boxData[i]);
      }
      setBoxData(newBoxData);

      //make other values reverse
    } else {
      for (let i = 0; i < boxData.length; i++) {
        if (boxData[i].boxId === box.boxId) {
          boxData[i].checked = false;
        } else {
          boxData[i].checked = false;
        }
        newBoxData.push(boxData[i]);
      }
      setBoxData(newBoxData);
    }
  };
  const onSubmitHandler = () => {
    setIsShowBtn(true);
    const selectedBox = boxData
      .filter((box) => box.checked === true)
      .map((box) => box.boxId);
    onClickHandler(code, { key1: selectedBox[0] }, tag);
    filterToggle && filterToggle(true);
  };

  const boxLocationStyles = {
    marginBottom: "2%",
    marginTop: "-3%",
    color: "#444",
  };
  const boxSelectionLineStyles = {
    width: "65px",
    borderTop: "1px solid grey",
    marginTop: "-12px",
    marginBottom: "11px",
    marginLeft: "31.5px",
  };

  useEffect(() => {
    if (boxData !== undefined && boxData !== null && boxData.length !== 0) {
      let element = document.getElementById("boxScroll");
      element.addEventListener("wheel", getScrollValue);

      function getScrollValue() {
        let position = $("#boxId-0").offset();

        let lastPositoin = $(`#boxId-${lastIndexChannel}`).offset();

        let isShowLastone = Math.abs(
          $(".BoxSelection-Scroller").width() - lastPositoin.left
        );
        if (position.left < 0) {
          setShowChannelLeft(true);
        } else {
          setShowChannelLeft(false);
        }

        if (isShowLastone > 134 && isShowLastone < 139) {
          setShowChannelRight(false);
        } else if (boxData.length < 3) {
          setShowChannelRight(false);
        } else {
          setShowChannelRight(true);
        }
      }

      return () => {
        element.removeEventListener("wheel", getScrollValue);
      };
    }
  }, [boxData, lastIndexChannel]);

  return (
    <div className="BoxSlectionContainer">
      <ScrollerWithArrows
        width="100%"
        height="12rem"
        isShowLeft={showChannelLeft}
        isShowRight={showChannelRight}
        setShowLeft={setShowChannelLeft}
        setShowRight={setShowChannelRight}
        lastIndex={lastIndexChannel}
        parentId="boxScroll"
        childId="boxId"
        minimumValue={134}
        maximumValue={139}
        ref={boxRef}
      >
        <div className="BoxSelection-Scroller" ref={boxRef} id="boxScroll">
          {boxData.length > 0 &&
            boxData.map((box, index) => {
              return (
                <div
                  value={box}
                  key={index}
                  id={`boxId-${index}`}
                  className="BoxSelection"
                  style={{
                    border:
                      box.checked === true
                        ? "1px solid #E10092"
                        : "1px solid #d6caca",
                    width: "40%",
                  }}
                  onClick={() => boxSelectionClickHandler(box)}
                >
                  <div className="BoxSelection-Radio">
                    <input
                      style={{ cursor: "pointer" }}
                      onChange={() => console.log(box.boxId)}
                      type="radio"
                      name="box"
                      id={box.boxId}
                      value={box.id}
                      checked={box.checked}
                    />
                  </div>
                  <div className="BoxSelection-room" style={boxLocationStyles}>
                    {box.location === "" ? "Box Location" : box.location}
                  </div>
                  <div className="BoxSelection-boxId">
                    <span>Box ID:</span>
                    {box?.boxId?.substr(box?.boxId?.length - 4)}
                  </div>

                  <div className="BoxSelection-image">
                    <img
                      src={box.imageLink}
                      alt=""
                      height="40px"
                      width={"65px"}
                      onError={(e) => (e.target.src = defaultBox)}
                    />
                  </div>
                  <div style={boxSelectionLineStyles}></div>
                  <hr className="hrContainer" />

                  <div className="BoxSelection-boxType">
                    ({box.description})
                  </div>
                </div>
              );
            })}
        </div>
      </ScrollerWithArrows>
      <div className="BoxSelection-button">
        <button
          // className={
          //   isShowBtn
          //     ? "BoxSelection-button-submit waves-effect waves-light"
          //     : "BoxSelection-button-submit waves-effect waves-light-disabled"
          // }
          onClick={() => onSubmitHandler()}
          // disabled={!isShowBtn}
        >
          {buttonText.toString()}
        </button>
      </div>
    </div>
  );
}
